import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './margin.css';
import { changeMarginType } from './../../../../redux/actions/ui/marginType';

class Margin extends Component {
  constructor(props) {
    super(props);
    this.wrapper = '';
    this.state = {
      opened: false,
    };
  }

  changeDropDown = () => {
    const { opened } = this.state;
    this.setState({
      opened: !opened,
    });
  }

  hideDropDown = () => {
    this.setState({
      opened: false,
    });
  }

  changeMarginType = (type) => {
    this.changeDropDown();
    this.props.dispatch(changeMarginType(type));
  }

  render() {
    const { opened } = this.state;
    const { lang } = this.props;
    const marginShow = opened ? 'show' : '';
    return (
      <div className={`marginWrapper ${marginShow}`}>
        <button
          ref={(wrapper) => { this.wrapper = wrapper; }}
          type="button"
          className="btn green-btn margin-btn"
          onClick={this.changeDropDown.bind(this)}
          onBlur={this.hideDropDown.bind(this)}
        >
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16">
            <path d="M0,0V16H28V0ZM27.06,15.06H.94V.94H27.06ZM26,14V2H2V14H26Z" />
          </svg>
          {lang.top_menu_margins}
        </button>
        <div className={`dropdown-menu ${marginShow}`} >
          <button
            className="dropdown-btn"
            onMouseDown={() => this.changeMarginType('HIDE')}
            type="button"
          >
            {lang.top_menu_margins_show_with_large_opacity}
          </button>
          <button
            className="dropdown-btn"
            onMouseDown={() => this.changeMarginType('SHOW_WITH_OPACITY')}
            type="button"
          >
            {lang.top_menu_margins_show_with_small_opacity}
          </button>
          <button
            className="dropdown-btn"
            onMouseDown={() => this.changeMarginType('')}
            type="button"
          >
            {lang.top_menu_dont_show_margins}
          </button>
        </div>
      </div>
    );
  }
}

Margin.defaultProps = {
  dispatch: () => {},
  lang: {},
};

Margin.propTypes = {
  dispatch: PropTypes.func,
  lang: PropTypes.object,
};

export default connect()(Margin);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/margin/margin.jsx